import { useState } from "react";
import { formatAge, formatDateTime, formatDurationUntil } from "../lib/time";
import { useRemote } from "../state/RemoteContext";

const labels: Record<string, string> = {
  "projection.read": "Read",
  "evidence.read": "Evidence",
  "manager.chat": "Manager chat",
  "attention.ack": "Acknowledge",
  "attention.snooze": "Snooze",
  "board.edit": "Board edit",
  "decision.respond": "Decisions",
  "run.pause": "Pause",
  "run.resume": "Resume",
};

export function SessionScreen({ onEnd }: { onEnd: () => Promise<void> }) {
  const { fixture, sourceKind } = useRemote();
  const { session } = fixture;
  const [ending, setEnding] = useState(false);
  const handleEnd = async () => {
    setEnding(true);
    try {
      await onEnd();
    } finally {
      setEnding(false);
    }
  };
  return (
    <div className="screen">
      <header className="screen-heading"><span className="eyebrow">Remote access and authority</span><h1>Session</h1><p>The client can be discarded; Forge remains authoritative.</p></header>
      <section className="session-card" aria-labelledby="session-detail-heading">
        <h2 id="session-detail-heading">Connection</h2>
        <dl>
          <div><dt>This device</dt><dd>{session.deviceLabel}</dd></div>
          <div><dt>Data source</dt><dd>{sourceKind === "development-fixture" ? "Development fixture · not live" : "Forge Remote Portal · live contract"}</dd></div>
          <div><dt>Gateway</dt><dd>{session.gateway.state} · {formatAge(session.gateway.lastConnectedAt)}</dd></div>
          <div><dt>Forge host</dt><dd>{session.hostLabel} · {session.host.state} · {formatAge(session.host.lastSeenAt)}</dd></div>
          <div><dt>Projection</dt><dd>{session.projection.state} · snapshot {formatAge(session.projection.snapshotAt)}</dd></div>
          <div><dt>Command authority</dt><dd>{session.commandAuthority.state} · {session.commandAuthority.reason}</dd></div>
          <div><dt>Expires</dt><dd>{formatDateTime(session.expiresAt)} · {formatDurationUntil(session.expiresAt)}</dd></div>
          <div><dt>Session</dt><dd className="mono">{session.sessionId}</dd></div>
        </dl>
      </section>
      <section className="session-card" aria-labelledby="access-heading">
        <h2 id="access-heading">Access · {session.preset}</h2>
        <div className="capability-list">{session.capabilities.map((capability) => <span className="capability-chip" key={capability}>{labels[capability]}</span>)}</div>
        <div className="denied-capabilities"><span>Cancel / stop</span><span>Code / terminal</span><span>Member provisioning</span></div>
        <p className="fine-print">Scope and permissions are managed by the authoritative Forge host. Disabled controls remain visible and explain the missing capability.</p>
      </section>
      <button type="button" className="danger-button" disabled={ending} onClick={() => void handleEnd()}>{ending ? "Ending session…" : "End session on this phone"}</button>
    </div>
  );
}
